var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('svg', {
    class: "fill-current  text-".concat(_vm.color),
    attrs: {
      "height": "".concat(_vm.height, "px"),
      "width": "".concat(_vm.width, "px"),
      "viewBox": "0 0 22 20",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M4.39835 19.7995C1.65046 17.735 0 14.5037 0 11C0 4.92487 4.92487 0 11 0C17.0751 0 22 4.92487 22 11C22 14.5037 20.3495 17.735 17.6017 19.7995L17.3348 20H4.66522L4.39835 19.7995ZM16.6575 18C18.753 16.305 20 13.757 20 11C20 6.02944 15.9706 2 11 2C6.02944 2 2 6.02944 2 11C2 13.757 3.24698 16.305 5.34253 18H16.6575ZM16.3192 5.57346L14.6808 4.42654L12.0477 8.18803C11.7216 8.06645 11.3685 8 11 8C9.34315 8 8 9.34315 8 11C8 12.6569 9.34315 14 11 14C12.6569 14 14 12.6569 14 11C14 10.4445 13.849 9.92435 13.5859 9.4782L16.3192 5.57346ZM12 11C12 11.5523 11.5523 12 11 12C10.4477 12 10 11.5523 10 11C10 10.4477 10.4477 10 11 10C11.5523 10 12 10.4477 12 11Z"
    }
  })]);
}
var staticRenderFns = []

export { render, staticRenderFns }